// extracted by mini-css-extract-plugin
export var icon = "ticket-large-module--icon--dFiof";
export var wrapper = "ticket-large-module--wrapper--DzL0V";